import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputBase,
  Popover,
  Tooltip,
} from '@material-ui/core';
import { Close, FilterList, Search } from '@material-ui/icons';
import { BLUE, BORDER, GREY_TEXT } from '../../AnalyticsV2.styled';
import DateRange from './DateRange';

const STATUS_OPTIONS = [
  { value: 'sent', label: 'Sent' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'cancelled', label: 'Cancelled' },
];

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 22px;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 318px;
  max-width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
`;

const FilterButton = styled(Button)`
  &.MuiButton-root {
    height: 44px;
    text-transform: none;
    font-size: 15px;
    color: #1c1c1c;
  }
`;

const FilterOptions = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
`;

const Selection = styled.span`
  font-size: 13px;
  color: ${GREY_TEXT};
`;

const ClearButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: ${BLUE};
  cursor: pointer;
`;

const Toolbar = ({
  searchText,
  onSearchTextChange,
  dateRange,
  onDateRangeChange,
  statuses,
  onStatusesChange,
  selectedCount,
  onClearSelection,
  // true while "Show selected messages only" is on: search, dates and Filter
  // are not applied, so they are disabled.
  areFiltersDisabled,
}) => {
  const [filterAnchor, setFilterAnchor] = useState(null);

  const toggleStatus = value => {
    onStatusesChange(
      statuses.includes(value)
        ? statuses.filter(status => status !== value)
        : [...statuses, value]
    );
  };

  return (
    <Row>
      <SearchBox>
        <Search style={{ color: '#1c1c1c' }} />
        <InputBase
          fullWidth
          placeholder="Search"
          value={searchText}
          onChange={event => onSearchTextChange(event.target.value)}
          disabled={areFiltersDisabled}
        />
        {searchText !== '' && !areFiltersDisabled && (
          <IconButton
            size="small"
            aria-label="Clear search"
            onClick={() => onSearchTextChange('')}
          >
            <Close fontSize="small" />
          </IconButton>
        )}
      </SearchBox>
      <Tooltip
        title={areFiltersDisabled ? 'Showing selected messages only' : ''}
        placement="top"
      >
        <span>
          <DateRange
            value={dateRange}
            onChange={onDateRangeChange}
            disabled={areFiltersDisabled}
          />
        </span>
      </Tooltip>
      <FilterButton
        disabled={areFiltersDisabled}
        startIcon={<FilterList />}
        onClick={event => setFilterAnchor(event.currentTarget)}
      >
        Filter
      </FilterButton>
      <Popover
        open={!!filterAnchor}
        anchorEl={filterAnchor}
        onClose={() => setFilterAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <FilterOptions>
          {STATUS_OPTIONS.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              label={label}
              control={
                <Checkbox
                  color="primary"
                  checked={statuses.includes(value)}
                  onChange={() => toggleStatus(value)}
                />
              }
            />
          ))}
        </FilterOptions>
      </Popover>
      {selectedCount > 0 && (
        <Selection>
          {selectedCount} selected ·{' '}
          <ClearButton onClick={onClearSelection}>Clear</ClearButton>
        </Selection>
      )}
    </Row>
  );
};

export default Toolbar;
